// extracted by mini-css-extract-plugin
export default {"linkButtonWrapper":"modal_linkButtonWrapper__Bbx7B","linkButton":"modal_linkButton__H8oPc","modal":"modal_modal__YsOnj","wrapper":"modal_wrapper__mKGZp"};